import { render, staticRenderFns } from "./OdooClientInstanceFormModal.vue?vue&type=template&id=7fe9f25e&scoped=true&"
import script from "./OdooClientInstanceFormModal.vue?vue&type=script&lang=js&"
export * from "./OdooClientInstanceFormModal.vue?vue&type=script&lang=js&"
import style0 from "./OdooClientInstanceFormModal.vue?vue&type=style&index=0&id=7fe9f25e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe9f25e",
  null
  
)

export default component.exports